export default __webpack_public_path__ + "content/media/29.7df91ac1.jpg";